import React from 'react'
import useSeo from '../../hooks/useSeo.ts'

const RefundPolicy = () => {
	useSeo({ title: 'Refund Policy | Wedding Camera', description: 'Wedding Camera refund policy.', path: '/refund-policy', lang: 'en' })
	return (
		<div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333', padding: '20px' }}>
			<h1 style={{ color: '#444' }}>Refund Policy</h1>
			<p><strong>Last updated:</strong> 27.12.2024</p>

			<h2 style={{ color: '#444' }}>General Policy</h2>
			<p>
				Due to the nature of digital products, all sales of Wedding Camera packages are final and non-refundable once the service has been activated.
			</p>

			<h2 style={{ color: '#444' }}>Exceptional Circumstances</h2>
			<p>We may issue refunds in the following cases:</p>
			<ul>
				<li>
					<strong>Technical Issues:</strong> If the service is unusable due to technical errors that are not resolved within 7 business days.
				</li>
				<li>
					<strong>Unauthorized Charges:</strong> If your account was charged without your authorization.
				</li>
			</ul>

			<h2 style={{ color: '#444' }}>Refund Request Process</h2>
			<p>To request a refund, contact us at <a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a> with the following details:</p>
			<ol>
				<li>Your account information.</li>
				<li>A detailed explanation of the issue.</li>
			</ol>
			<p>Refund requests are evaluated on a case-by-case basis and processed within 14 business days.</p>

			<h2 style={{ color: '#444' }}>Contact Us</h2>
			<p>
				For refund-related inquiries, email us at <a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a>.
			</p>
		</div>
	)
}

export default RefundPolicy
